module.exports = __webpack_public_path__ + "f533b65cc64c004c487306975408b8dd.svg";